module.exports = __webpack_public_path__ + "img/value-teaser-04.5c244734.jpg";